import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

export default function ImageCropperModal({ 
    show, 
    onHide, 
    imageSrc, 
    onSave, 
    circularCrop = false,
    aspectRatio = 1 
}) {
    const [crop, setCrop] = useState();
    const [completedCrop, setCompletedCrop] = useState(null);
    const imgRef = useRef(null);

    // Reset crop on new image
    useEffect(() => {
        setCrop(undefined);
        setCompletedCrop(null);
    }, [imageSrc]);

    function onImageLoad(e) {
        const { width, height } = e.currentTarget;
        // Default crop size to 90% of image (adjust as necessary)
        const cropSettings = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 90,
                },
                aspectRatio,
                width,
                height
            ),
            width,
            height
        );
        setCrop(cropSettings);
    }

    const handleSave = () => {
        if (!completedCrop || !imgRef.current) {
            onHide();
            return;
        }

        const canvas = document.createElement('canvas');
        const image = imgRef.current;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        
        canvas.width = completedCrop.width * scaleX;
        canvas.height = completedCrop.height * scaleY;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            canvas.width,
            canvas.height
        );

        canvas.toBlob((blob) => {
            if (blob) {
                onSave(blob);
            }
        }, 'image/jpeg', 0.95);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Crop Image</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                {imageSrc ? (
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                        onComplete={(c) => setCompletedCrop(c)}
                        aspect={aspectRatio}
                        circularCrop={circularCrop}
                    >
                        <img 
                            ref={imgRef} 
                            src={imageSrc} 
                            alt="Crop preview" 
                            onLoad={onImageLoad}
                            style={{ maxHeight: '60vh', maxWidth: '100%', objectFit: 'contain' }}
                        />
                    </ReactCrop>
                ) : (
                    <div>Loading...</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Crop & Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
